
export const GPS_STATE_NOT_SUPPORTED = -1;
export const GPS_STATE_UNKNOWN = 0;
export const GPS_STATE_USER_DISABLED = 1;
export const GPS_STATE_CAMPAIGN_DISABLED = 3;
export const GPS_STATE_BOTH = 10;

/**
 * Contains all information about a GPS collect
 */
export default class GpsInfos {

    /**
     * @param {int} status
     * @param {number|null} lat
     * @param {number|null} long
     * @param {number|null} timestamp
     * @param {number|null} radius
     * @param {string|null} city
     * @param {string|null} country
     * @param {string|null} countryCode
     * @param {string|null} postalCode
     * @param {string|null} streetNumber
     * @param {string|null} streetName
     */
    constructor(status = GPS_STATE_UNKNOWN, lat = null, long = null, timestamp = null, radius = null, city = null, country = null, countryCode = null, postalCode = null, streetNumber = null, streetName = null) {
        this.status = status;
        this.lat = lat;
        this.long = long;
        this.timestamp = timestamp;
        this.radius = radius;
        this.city = city;
        this.country = country;
        this.countryCode = countryCode;
        this.postalCode = postalCode;
        this.streetNumber = streetNumber;
        this.streetName = streetName;
        Object.freeze(this);
    }
}



// WEBPACK FOOTER //
// ./js/core/gps/GpsInfos.js